import { useTranslation } from "react-i18next";
import { Link } from "@/components/link";
import { CirclePlus } from "lucide-react";

interface AddItemButtonProps {
  path: string;
  labelKey: string;
}

export default function AddItemButton({ path, labelKey }: AddItemButtonProps) {
  const { t } = useTranslation();
  return (
    <Link to={path}>
      <CirclePlus className="w-5 h-5 mr-1" />
      {t(labelKey)}
    </Link>
  );
}
